import { render, staticRenderFns } from "./Spcjxx.vue?vue&type=template&id=f8e8f658&scoped=true"
import script from "./Spcjxx.vue?vue&type=script&lang=js"
export * from "./Spcjxx.vue?vue&type=script&lang=js"
import style0 from "./Spcjxx.vue?vue&type=style&index=0&id=f8e8f658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e8f658",
  null
  
)

export default component.exports